import React from 'react';

import './index.scss';

export default function Tag({children, ...props}) {
    return <div className="tag" {...props}>{children}</div>;
}



// WEBPACK FOOTER //
// ./components/tag/index.js